module.exports = __webpack_public_path__ + "c_static/img/7货比三家.c73921d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/7货比三家.jpg
// module id = 7kgB
// module chunks = 33